export default __webpack_public_path__ + "static/media/pr_c_25.f9de3758.jpg";